import pick from 'lodash/fp/pick';

import config from '@config';

import createDataSource from '../createDataSource';
import { getDefaultEmptyList, getDefaultListHandler } from '../utils';

import { MINISITE_FILTER_KEY } from './constants';

const BASE_PATHNAME = 'assets';

export default () => {
  const dataSource = createDataSource(`${config.api.url}`);

  const getById = ({ id, language = 'en' }) => {
    return dataSource.get(`${BASE_PATHNAME}/${id}/${language}`).json();
  };

  const getByIds = ({ ids }) => Promise.all(ids.map((id) => getById({ id })));

  const remove = ({ id, contentId, language }) => {
    if (contentId) {
      return dataSource.delete(`${BASE_PATHNAME}/${contentId}/${language}`);
    }
    return dataSource.delete(`${BASE_PATHNAME}/${id}/${language}`);
  };

  const create = ({ values, language = 'en' }) =>
    dataSource.post(BASE_PATHNAME, { json: { language, ...values } }).json();
  const update = ({ id, values, language = 'en' }) =>
    dataSource.put(`${BASE_PATHNAME}`, { json: { id, language, ...values } }).json();

  const publish = async ({ id, values }) => {
    const asset = await (id ? update({ id, values }) : create({ values }));
    return dataSource.put(`${BASE_PATHNAME}/${asset.id}/${asset.language}/publish`).json();
  };

  const getTypeList = () => dataSource.get('asset-types').json();

  const unpublish = ({ id, contentId, language }) => {
    if (contentId) {
      return dataSource.put(`${BASE_PATHNAME}/${contentId}/${language}/unpublish`).json();
    }
    return dataSource.put(`${BASE_PATHNAME}/${id}/unpublish`).json();
  };

  const duplicate = ({ contentId }) => dataSource.post(`${BASE_PATHNAME}/${contentId}/duplicate`).json();

  return {
    getList: getDefaultListHandler({
      url: BASE_PATHNAME,
      dataSource,
      transformFilter: pick([MINISITE_FILTER_KEY]),
      defaultFilters: { language: 'en' },
    }),

    getTypeList,

    getById,

    getByIds,

    remove,

    create,

    update,

    publish,

    unpublish,

    duplicate,

    getEmptyList: getDefaultEmptyList,
  };
};
